import { ValidationState } from '@sparemin/blockhead';
import { FieldErrors, FieldValues } from 'react-hook-form';

export function getValidationState<TFieldValues extends FieldValues>(
  errors: FieldErrors<TFieldValues>,
  key: keyof TFieldValues,
): ValidationState {
  return errors[key] ? 'invalid' : 'valid';
}
